import { defineRecipe, SystemStyleObject } from '@chakra-ui/react'

const common: SystemStyleObject = {
    textUnderlineOffset: '3px',
    _light: {
        color: 'black',
    },
    _dark: {
        color: 'white',
    },
}

export const linkRecipe = defineRecipe({
    base: {
        ...common,
        _hover: {
            ...common,
        },
        _focus: {
            outlineColor: 'transparent',
        },
    },
})
